// extracted by mini-css-extract-plugin
module.exports = {"Omega":"Omega__1jt_h"};